import { FullContainer } from '@gorila-shared-ui/components';
import { useStyles } from '../../../hooks/useStyles';
import MaintenanceTypeList from '../../maintenances/types/MaintenanceTypeList';
import MaintenanceTypesFiltersBar from '../../maintenances/types/MaintenanceTypesFiltersBar';

function MaintenanceTypesPage() {
  const { classes } = useStyles();

  return (
    <FullContainer
      verticalFlex
      classNames={classes.basicPageContainer}
    >
      <MaintenanceTypesFiltersBar />
      <MaintenanceTypeList />
    </FullContainer>
  );
}

export default MaintenanceTypesPage;
